// ../zql/src/query/ttl.ts
var DEFAULT_TTL = "none";
var multiplier = {
  s: 1e3,
  m: 60 * 1e3,
  h: 60 * 60 * 1e3,
  d: 24 * 60 * 60 * 1e3,
  y: 365 * 24 * 60 * 60 * 1e3
};
function parseTTL(ttl) {
  if (typeof ttl === "number") {
    return Number.isNaN(ttl) ? 0 : !Number.isFinite(ttl) || ttl < 0 ? -1 : ttl;
  }
  if (ttl === "none") {
    return 0;
  }
  if (ttl === "forever") {
    return -1;
  }
  const multi = multiplier[ttl[ttl.length - 1]];
  return Number(ttl.slice(0, -1)) * multi;
}
function compareTTL(a, b) {
  const ap = parseTTL(a);
  const bp = parseTTL(b);
  if (ap === -1 && bp !== -1) {
    return 1;
  }
  if (ap !== -1 && bp === -1) {
    return -1;
  }
  return ap - bp;
}
function normalizeTTL(ttl) {
  if (typeof ttl === "string") {
    return ttl;
  }
  if (ttl < 0) {
    return "forever";
  }
  if (ttl === 0) {
    return "none";
  }
  let shortest = ttl.toString();
  const lengthOfNumber = shortest.length;
  for (const unit of ["y", "d", "h", "m", "s"]) {
    const multi = multiplier[unit];
    const value = ttl / multi;
    const candidate = `${value}${unit}`;
    if (candidate.length < shortest.length) {
      shortest = candidate;
    }
  }
  return shortest.length < lengthOfNumber ? shortest : ttl;
}

// ../shared/src/has-own.ts
var { hasOwn } = Object;

export {
  hasOwn,
  DEFAULT_TTL,
  parseTTL,
  compareTTL,
  normalizeTTL
};
//# sourceMappingURL=chunk-MB3DEFRC.js.map
